module.exports = __webpack_public_path__ + "static/assets/a241274b32975fbc37f09c54003b2e50.svg";